import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { CitadelNotificationService } from '@citadel/core';
import { debounceTime } from 'rxjs';
import { RegistrationService } from 'src/app/services/registration-service.service';
import { SignInService } from 'src/app/services/sign-in-service';

@Component({
  selector: 'app-sign-in-otp-channel-step',
  templateUrl: './sign-in-otp-channel-step.component.html',
  styleUrls: ['./sign-in-otp-channel-step.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SignInOtpChannelStepComponent {
  private router = inject(Router);
  private registration = inject(RegistrationService);
  private notify = inject(CitadelNotificationService);
  private signInService = inject(SignInService);

  private defaultErrorMessage: string = 'An error occurred. Please try again';
  // Two-way bound via [(ngModel)] in the template; unset until the user picks an OTP channel.
  protected otpType = this.signInService.otpType();
  protected showChannelRequiredMsg: boolean = false;

  protected otpTypeLabels = [
    { label: "SMS", value: "SMS" },
    { label: "WhatsApp", value: "WhatsApp" }
  ];

  // Not read for its shape - only tested for truthiness.
  protected onOtpChannelChange(e: unknown): void {
    if (e && this.otpType) {
      this.showChannelRequiredMsg = false;
    }
  }

  protected sendOtp(): void {
    // Back here from OTP entry: the OTP already sent is still good, so go straight back to it.
    if (this.signInService.otpSent()) {
      this.router.navigate(['/sign-in', 'otp']);
    } else if (this.otpType) {
      const otpType = this.otpType;
      this.registration.sendOtp(otpType, this.signInService.account()?.requestID ?? '')
        .pipe(debounceTime(2000))
        .subscribe({
          next: _ => {
            this.notify.success('OTP sent', "");
            this.signInService.otpType.set(otpType);
            this.signInService.otpSent.set(true);
            this.router.navigate(['/sign-in', 'otp']);
          }, error: _ => this.notify.error(this.defaultErrorMessage, "")
        });
    } else {
      this.showChannelRequiredMsg = true;
      this.notify.error('Please select an option before you continue', " ");
    }
  }

  protected handleKeyUp(e: KeyboardEvent) {
    if (e.keyCode === 13) {
      this.sendOtp();
    }
  }
}
